<template>
  <div>
    <error slot="description" :errors="errors"/>
    <success :success="success"/>
    <div class="md-layout"  style="overflow-y: scroll;overflow: no-display; height: 668px">

      <div
          class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
          v-for="(colorant) in colorants" :key="colorant.name"
      >
        <b-button class="text-white w-100" v-b-toggle="'collapse_colorant-'+colorant.name" variant="light" style="background-color: #184277">
          {{ colorant.name }}
          <md-icon>expand_more</md-icon>
        </b-button>

        <b-collapse :id="'collapse_colorant-'+colorant.name" >
          <md-field>
            <label>Баланс, л</label>
            <md-input v-model="colorant.data_colorant.balance" type="number"
                      @keypress="isLetter($event)"></md-input>
          </md-field>
          <md-field>
            <label>Цена покупки, грн</label>
            <md-input v-model="colorant.data_colorant.purchase_price" type="number"
                      @keypress="isLetter($event)"></md-input>
          </md-field>
          <md-field>
            <label>Цена продажи, грн</label>
            <md-input v-model="colorant.data_colorant.selling_price" type="number"
                      @keypress="isLetter($event)"></md-input>
          </md-field>

        </b-collapse>

      </div>
    </div>
    <md-button class="md-warning" @click="sendChangePrice(systemColorants)">Изменить</md-button>
  </div>
</template>

<script>
import Error from "./Error";
import Success from "./Success";
import {mapActions} from "vuex";

export default {
  name: "UserColorants",
  components: {Success, Error},
  props: ['colorants', 'systemColorants'],
  data() {
    return {
      price_colorants: [],
      errors: null,
      success: null,
    }
  },
  methods: {
    ...mapActions(["account/changePriceColorant"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/[[0-9.]/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    sendChangePrice(systemColorants) {
      for (let i in this.colorants) {
          if (this.colorants[i].data_colorant.purchase_price || this.colorants[i].data_colorant.selling_price || this.colorants[i].data_colorant.balance) {
            this.price_colorants.push({
              colorant_id: this.colorants[i].id,
              balance: this.colorants[i].data_colorant.balance,
              purchase_price: this.colorants[i].data_colorant.purchase_price,
              selling_price: this.colorants[i].data_colorant.selling_price
            });
          }
      }
      this.price_colorants.unshift(systemColorants);

      this.$store.dispatch('account/changePriceColorant', this.price_colorants)
          .then(() => {
            this.price_colorants = [];
            this.success = [
              'Данные успешно изменены'
            ]
          })
          .catch(err => {
            this.errors = [];
            if (err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    }
  }
}
</script>

<style scoped>

</style>